export const PAGE_MAIN = 'MAIN';
export const PAGE_CHANNEL = 'CHANNEL';
export const PAGE_PLAYER = 'PLAYER';
export const PAGE_SEARCH = 'SEARCH';
export const PAGE_SEARCH_PLAYER = 'SEARCH_PLAYER';

export const PAGE_ENUMS = [PAGE_MAIN, PAGE_CHANNEL, PAGE_PLAYER, PAGE_SEARCH] as const;
